export default "__VITE_ASSET__65733aaa__"